import React from "react";
import AboutHero from "../Components/AboutHero/AboutHero";
import FounderSection from "../Components/FounderSection/FounderSection";
import ImageSlider from "../Components/ImageSlider/ImageSlider";
import MissionVision from "../Components/MissionVision/MissionVision";
import BookSection from "../Components/BookSection/BookSection";
import CoreTeam from "../Components/CoreTeam/CoreTeam";

const About = () => {
  return (
    <>
      <AboutHero />
      <FounderSection />
      <ImageSlider />
      <MissionVision />
      <BookSection />
      <CoreTeam />

      {/* Your remaining About Page sections here */}
    </>
  );
};

export default About;
